import React from 'react';
import hotel from '../../../../static/icons/sts_hotel.svg';

const STSHotelIcon = () => {
  return <img src={hotel} alt={'STS Hotel'} />;
};

export default STSHotelIcon;
